module.exports = __webpack_public_path__ + "static/site-image-800x418-7cff2a404d6a2e7a7cb5d325a6cf9291.png";